<div class="modal-header always-enabled">
  <h4 class="modal-title" id="upload-modal-title">Upload Excel file</h4>
  <div class="btn-close-wrapper rounded-circle position-absolute end-0 me-3">
    <button type="button" class="btn-close m-0" aria-label="Close button" aria-describedby="upload-modal-title"
            (click)="cancel()"></button>
  </div>
</div>
<div class="modal-body">
  <p class="text-muted">Upload an Excel file using the section below. The data from the Excel file will be used
    and validated inside the table.</p>
  @if (errorMessage()) {
    <div class="alert alert-danger d-flex align-items-center" role="alert">
      <i class="fa-light fa-circle-exclamation fa-fw me-2" aria-hidden="true"></i>
      <span>{{ errorMessage() }}</span>
    </div>
  }
  @if (selectedFile()) {
    <div class="file-card d-flex align-items-center justify-content-between p-3"
         (dragenter)="onDragEnter($event)"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         (click)="fileInput.click()">
      <div class="d-flex align-items-center">
        <span class="file-card-check rounded-circle d-inline-flex align-items-center justify-content-center me-2">
          <i class="fa-light fa-check" aria-hidden="true"></i>
        </span>
        <span>{{ selectedFile().name }}</span>
      </div>
      <button type="button" class="btn btn-link link-danger text-decoration-none p-0 d-flex align-items-center"
              (click)="removeFile($event)">
        <i class="fa-light fa-trash-can me-1" aria-hidden="true"></i>
        <span>Remove</span>
      </button>
      <input #fileInput type="file" hidden accept=".xlsx,.xls" (change)="onFileInputChange($event)">
    </div>
  } @else {
    <div class="dropzone d-flex flex-column align-items-center justify-content-center text-center p-4"
         [class.dropzone-active]="dragOver()"
         (dragenter)="onDragEnter($event)"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)"
         (click)="fileInput.click()">
      <button type="button" class="btn btn-outline-info">
        <i class="me-2 fa-light fa-cloud-arrow-up" aria-hidden="true"></i>
        <span>Upload</span>
      </button>
      <span class="text-muted mt-2">or drop your .xls or .xlsx file in this area</span>
      <input #fileInput type="file" hidden accept=".xlsx,.xls" (change)="onFileInputChange($event)">
    </div>
  }
</div>
<div class="modal-footer">
  <a [href]="templateUrl" class="btn btn-link link-primary text-decoration-none ps-0 me-auto">
    <i class="me-2 fa-light fa-arrow-down-to-line" aria-hidden="true"></i>
    <span>Download template</span>
  </a>
  <button type="button" class="btn btn-outline-secondary me-3" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary" [disabled]="!canAddToTable()" (click)="addToTable()">Add to table</button>
</div>
